<template>
  <div>
    <!-- 面包屑 -->
    <bread-crumb path='内容管理' subPath='内容列表'></bread-crumb>
    <!-- 主体列表 -->
    <el-card>
      <el-row :gutter="20">
        <el-col :span="24">
          <el-dropdown>
            <el-button type="primary">批量操作<i class="el-icon-arrow-down el-icon--right"></i></el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item><span @click="showUpdateCategoryDialog">修改专辑</span></el-dropdown-item>
              <el-dropdown-item><span @click="multiDeletePost">删除</span></el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>&nbsp;
          <el-button type="primary" @click="showAddDialog">添加内容</el-button>&nbsp;
          <el-select v-model="param.category_id" placeholder="请选择专辑" filterable clearable @change="search">
            <el-option label="请选择专辑" :value="0"></el-option>
            <el-option v-for="item in categoryList" :key="item.id" :label="item.title" :value="item.id"></el-option>
          </el-select>&nbsp;
          <el-select v-model="param.author_id" placeholder="请选择作者" filterable clearable @change="search">
            <el-option label="全部作者" :value="0"></el-option>
            <el-option v-for="item in authorList" :key="item.id" :label="item.title" :value="item.id"></el-option>
          </el-select>&nbsp;
          <el-select v-model="param.translation_status" placeholder="翻译状态" clearable @change="search">
            <el-option label="全部翻译状态" :value="0"></el-option>
            <el-option label="已翻译" :value="1"></el-option>
            <el-option label="未翻译/未完成" :value="2"></el-option>
          </el-select>&nbsp;
          <el-select v-model="param.sort_by" placeholder="请选择排序" @change="getContentList">
            <el-option label="按发布时间排序" :value="2"></el-option>
            <el-option label="按创建时间排序" :value="1"></el-option>
          </el-select>&nbsp;
          <el-input placeholder="请输入标题" style="width: 350px;" v-model="param.keywords" clearable @clear="search">
            <el-button slot="append" icon="el-icon-search" @click="search"></el-button>
          </el-input>
        </el-col>
      </el-row>
    </el-card>
   <el-table :data="contentList" @selection-change="handleSelectionChange" stripe border :cell-style="{ textAlign: 'center' }">
      <el-table-column type="selection" width="40" align="center"></el-table-column>
      <el-table-column prop="id" label="ID" align="center" width="60px"></el-table-column>
      <el-table-column prop="pic" label="图片" align="center">
        <template slot-scope="scope">
          <el-image v-if="scope.row.pic!=''" :src="scope.row.pic+'?imageView2/2/w/75'"></el-image>
        </template>
      </el-table-column>
      <el-table-column label="标题" align="center" width="270px">
        <template slot-scope="scope">
          <a :href="scope.row.url" target="_blank">{{scope.row.title}}</a>
        </template>
      </el-table-column>
      <el-table-column prop="category_title" label="分类" align="center"></el-table-column>
      <el-table-column prop="character_title" label="特色栏目" align="center"></el-table-column>
      <el-table-column label="作者" align="center">
        <template slot-scope="scope">
          {{scope.row.author_id | getAuthorName(authorList)}}
        </template>
      </el-table-column>
      <el-table-column prop="hits" label="点击量" align="center" width="80px"></el-table-column>
      <el-table-column label="状态" align="center" width="90px">
        <template slot-scope="scope">
          <el-tag :type="scope.row.status === 1 ? 'success' : 'info'" size="mini">
            {{ scope.row.status === 1 ? '已发布' : '草稿' }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="发布时间" align="center">
        <template slot-scope="scope">
          {{scope.row.publish_start | dateTimeFormat}}
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" width="360px">
        <template slot-scope="scope">
          <el-button type="primary" icon="el-icon-edit" size="mini" @click="showEditDialog(scope.row.id)">编辑</el-button>
          <el-button type="success" icon="el-icon-connection" size="mini" @click="showRelatedPage(scope.row)">相关文章</el-button>
          <el-button type="danger" icon="el-icon-delete" size="mini" @click="deleteRow(scope.row.id)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
   <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="param.page"
      :page-sizes="[10, 20, 30, 40, 50]"
      :page-size="param.count"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total">
    </el-pagination>
   <content-add :visible="addDialogAvaible"
      :id="currentId"
      :categoryList="categoryList"
      @add="addContent"
      @update="updateContent"
      @close="closeAddDialog">
    </content-add>
    <category-update :visible="updateCategoryAvaible"
       :categoryList="categoryList"
       :authorList="authorList"
       @update="multiUpdateCategoryPost"
       @close="closeUpdateCategoryDialog">
     </category-update>
  </div>
</template>

<script>
import BreadCrumb from '../BreadCrumb.vue'
import ContentAdd from './ContentAdd.vue'
import CategoryUpdate from './categoryUpdate.vue'
export default {
  name: 'content_list',
  components: {
    'bread-crumb': BreadCrumb,
    'content-add': ContentAdd,
    'category-update': CategoryUpdate
  },
  mounted () {
    if (this.$route.query.param !== undefined) {
      this.param = JSON.parse(this.$route.query.param)
    }
    if (!this.param.sort_by) {
      this.param.sort_by = 2
    }
    if (this.param.author_id === undefined) {
      this.param.author_id = 0
    }
    this.param.news_index = process.env.VUE_APP_NEWS_INDEX
    this.getCategoryList()
    this.getAuthorList()
    this.getContentList()
  },
  data () {
    return {
      categoryList: [],
      authorList: [],
      contentList: [],
      currentId: 0,
      total: 0,
      pageTotal: 1,
      param: {
        category_id: 0,
        author_id: 0,
        keywords: '',
        sort_by: 2,
        translation_status: 0,
        news_index: 1,
        page: 1,
        count: 10
      },
      addDialogAvaible: false,
      idList: [],
      updateCategoryAvaible: false
    }
  },
  filters: {
    getAuthorName (id, authorList) {
      for (var i = 0; i < authorList.length; i++) {
        if (authorList[i].id === id) {
          return authorList[i].title
        }
      }
      return ''
    }
  },
  methods: {
    handleSelectionChange (val) {
      this.idList = []
      val.forEach(row => {
        this.idList.push(row.id)
      })
    },
    async getCategoryList () {
      const res = await this.$http.get('/admin/category/select_list')
      if (res.code === 0) {
        this.categoryList = res.data || []
      } else {
        this.$message.error(res.msg)
      }
    },
    async getAuthorList () {
      const res = await this.$http.get('/admin/author/select_list')
      if (res.code === 0) {
        this.authorList = res.data
      } else {
        this.$message.error(res.msg)
      }
    },
    async getContentList () {
      const res = await this.$http.get('/admin/content/list', this.param)
      if (res.code === 0) {
        this.contentList = res.data.list
        this.total = res.data.total
        this.pageTotal = res.data.total_page
        this.canComment = res.data.can_comment
      } else {
        this.$message.error(res.msg)
      }
    },
    search () {
      this.param.page = 1
      this.getContentList()
    },
    handleSizeChange (size) {
      this.param.count = size
      this.getContentList()
    },
    handleCurrentChange (page) {
      this.param.page = page
      this.getContentList()
    },
    showAddDialog () {
      // this.addDialogAvaible = true
      this.$router.push('/content/add?id=' + this.currentId + '&param=' + JSON.stringify(this.param))
    },
    closeAddDialog () {
      this.addDialogAvaible = false
      this.currentId = 0
    },
    showEditDialog (id) {
      this.currentId = id
      this.showAddDialog()
    },
    showRelatedPage (row) {
      this.$router.push('/content/related?id=' + row.id + '&title=' + encodeURIComponent(row.title) + '&param=' + JSON.stringify(this.param))
    },
    deleteRow (id) {
      this.$confirm('是否真的要删除此记录?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const res = await this.$http.post('/admin/content/delete/' + id)
        if (res.code === 0) {
          this.$message.success('删除成功')
          this.getContentList()
        } else {
          this.$message.error(res.msg)
        }
      }).catch(() => {})
    },
    multiDeletePost () {
      if (this.idList.length === 0) {
        return
      }
      this.$confirm('是否真的要删除这些内容?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const res = await this.$http.post('/admin/content/multi/delete', { ids: this.idList })
        if (res.code === 0) {
          this.$message.success('删除成功')
          this.getContentList()
        } else {
          this.$message.error(res.msg)
        }
      }).catch(() => {})
    },
    async addContent (data) {
      const res = await this.$http.post('/admin/content/add', data)
      if (res.code === 0) {
        this.closeAddDialog()
        this.getContentList()
      } else {
        this.$message.error(res.msg)
      }
    },
    async updateContent (id, data) {
      const res = await this.$http.post('/admin/content/update/' + id, data)
      if (res.code === 0) {
        this.closeAddDialog()
        this.getContentList()
      } else {
        this.$message.error(res.msg)
      }
    },
    async securityCheck (id) {
      const res = await this.$http.post('/admin/content/security_check/' + id)
      if (res.code === 0) {
        this.$message.success('检测成功')
        this.getContentList()
      } else {
        this.$message.error(res.msg)
      }
    },
    showUpdateCategoryDialog () {
      this.updateCategoryAvaible = true
    },
    closeUpdateCategoryDialog () {
      this.updateCategoryAvaible = false
    },
    async multiUpdateCategoryPost (categoryId) {
      if (this.idList.length === 0) {
        this.closeUpdateCategoryDialog()
        return
      }
      const res = await this.$http.post('/admin/content/multi/change/category', {
        ids: this.idList,
        category_id: categoryId
      })
      if (res.code === 0) {
        this.closeUpdateCategoryDialog()
        this.getContentList()
      } else {
        this.$message.error(res.msg)
      }
    },
    handleWebSuccess () {
      this.$message.success('上传成功')
    }
  }
}
</script>

<style scoped>
.list_img {
  width: 50px;
}
</style>
